import { render } from "./Phone_Number_Prompt_Modal.vue?vue&type=template&id=400f1efa&scoped=true"
import script from "./Phone_Number_Prompt_Modal.vue?vue&type=script&lang=js"
export * from "./Phone_Number_Prompt_Modal.vue?vue&type=script&lang=js"

import "./Phone_Number_Prompt_Modal.vue?vue&type=style&index=0&id=400f1efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400f1efa"]])

export default __exports__